import { SvgLogo } from "@/shared/ui/svg"
import styles from "./styles.module.scss"
import { Button } from "@/components/ui/button"
import {
  ChevronLeftCircle,
  ClipboardPaste,
  FileText,
  Globe,
  Image,
} from "lucide-react"
import { useAppSidebarStore } from "../model"
import { cn } from "@/lib/utils"
import { useAutoTranslation, useModalStore } from "@/entities"
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import {
  DISCOVERED_TRANSLATION_KEYS,
  LANG_KEYS,
  ROUTER_PATHS,
} from "@/shared/constants"
import {
  CreateContentWithTextModal,
  CreateContentWithWebUrlModal,
  DragAndDropCreateNote,
} from "@/widgets"
import { useCreateNoteImages, useCreateNoteUploadFile } from "@/features"
import { Modal } from "@/shared/types"

export const LayoutAppSidebar = () => {
  const { t } = useAutoTranslation()
  const setIsOpened = useAppSidebarStore(s => s.setIsOpened)
  const isOpened = useAppSidebarStore(s => s.isOpened)
  const { handleFileUpload } = useCreateNoteUploadFile()
  const { handleImagesUpload } = useCreateNoteImages()
  const openModal = useModalStore(s => s.openModal)
  const navigate = useNavigate()

  const handleWebUrlCreation = () => {
    openModal(
      Modal.CREATE_CONTENT_WITH_WEB_URL,
      <CreateContentWithWebUrlModal />
    )
  }

  const handleTextCreation = () => {
    openModal(Modal.CREATE_CONTENT_WITH_TEXT, <CreateContentWithTextModal />)
  }

  const createElements = [
    {
      title: t(LANG_KEYS.DOCUMENTS),
      icon: <FileText className="text-primary size-4" />,
      cb: handleFileUpload,
    },
    {
      title: t(LANG_KEYS.WEB_ARTICLES_SITES),
      icon: <Globe className="text-primary size-4" />,
      cb: handleWebUrlCreation,
    },
    {
      title: t(LANG_KEYS.PASTED_TEXT),
      icon: <ClipboardPaste className="text-primary size-4" />,
      cb: handleTextCreation,
    },
    {
      title: t(LANG_KEYS.TEXT_FROM_IMAGES),
      icon: <Image className="text-primary size-4" />,
      cb: handleImagesUpload,
    },
  ]

  useEffect(() => {
    const handler = () => {
      if (window.innerWidth < 1366) {
        setIsOpened(false)
      }
    }

    window.addEventListener("resize", handler)
    return () => {
      window.removeEventListener("resize", handler)
    }
  }, [])

  return (
    <aside
      className={cn(styles.aside, {
        [styles.aside_disabled]: !isOpened,
      })}
    >
      <div className={styles.aside__content}>
        <div className={styles.aside__top}>
          <div
            className={styles.aside__top__left}
            onClick={() => navigate(ROUTER_PATHS.APP_LIBRARY)}
          >
            <SvgLogo className="h-10 w-10" />
            <span className={styles.aside__top__brand}>Frateca</span>
          </div>

          <div className={styles.aside__top__right}>
            <Button
              variant="outline"
              size="icon"
              onClick={() => setIsOpened(false)}
            >
              <ChevronLeftCircle size={24} />
            </Button>
          </div>
        </div>

        <div className={styles.aside__inner}>
          {/* TODO HANDLE RELIABLE ENTITY FOR CONTINUE LISTENING FEATURE */}
          {/* <div className="mb-4">
            <h3 className={styles.title}>Continue Listening</h3>
            <div>[CONTINUE LISTENING...]</div>
          </div> */}

          <div className="mb-4">
            <h3 className={styles.title}>
              {t(DISCOVERED_TRANSLATION_KEYS.UPLOAD_FILES)}
            </h3>
            <div>
              {createElements.map(({ title, icon, cb }) => (
                <button
                  type="button"
                  key={`SIDEBAR_CREATE_ELEMENT_${title}`}
                  onClick={cb}
                  className={styles.createElement}
                >
                  {icon}
                  <span>{title}</span>
                </button>
              ))}
            </div>
          </div>

          {/* TODO HANDLE RELIABLE ENTITY FOR RECENTLY CREATED FEATURE */}
          {/* <div className="mb-4">
            <h3 className={styles.title}>Recent</h3>
            <div>[RECENTLY CREATED]</div>
          </div> */}

          <DragAndDropCreateNote />
        </div>
      </div>
    </aside>
  )
}
